export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500">有漫画推荐、合作建议或问题反馈？欢迎联系</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">business@hanhanmanga.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/60 hover:border-accent-200/60 transition-colors cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-xl">
                <i className="ri-chat-3-line text-accent-700 text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">submit@hanhanmanga.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/60 hover:border-secondary-200/60 transition-colors cursor-pointer">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-secondary-100 rounded-xl">
                <i className="ri-question-answer-line text-secondary-700 text-xl"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">support@hanhanmanga.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}